module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Medium TH.c5d9a086.eot";